import React from 'react';
import {
	Breadcrumb,
	Card,
	Row,
	Col,
	Button,
	Input,
	Table,
	Tag,
	Tabs,
	Typography,
	message,
	Space,
} from 'antd';
import {
	SearchOutlined,
	ReloadOutlined,
	UnorderedListOutlined,
	CarOutlined,
	CheckCircleOutlined,
	WarningOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	setConfig,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import Cookies from 'js-cookie';

const configClass = {
	title: 'List Tunggakan Kendaraan',
	apiUrl: {
		list: 'analitik/api/tunggakan/list/',
	},
	breadCrumb: [
		<span><CarOutlined /> Analitik</span>,
		'List Tunggakan',
	],
};

const config = new Config();

const JENIS_KEND_MAP = {
	A: 'SEDAN', B: 'JEEP', C: 'MINIBUS', D: 'MICROBUS',
	E: 'BUS', F: 'PICK UP', G: 'LIGHT TRUCK', H: 'TRUCK',
	R: 'SPD MOTOR R2', S: 'SPD MOTOR R3',
};

const namaJenis = (kode) => JENIS_KEND_MAP[(kode || '').toUpperCase().trim()] || 'Lainnya';

const WARNA_CONFIG = {
	PUTIH:   { color: '#262626', background: '#f5f5f5', border: '#d9d9d9', label: 'Putih (Pribadi)' },
	MERAH:   { color: '#fff',    background: '#f5222d', border: '#f5222d', label: 'Merah (Dinas)'   },
	KUNING:  { color: '#262626', background: '#faad14', border: '#faad14', label: 'Kuning (Umum)'   },
	LAINNYA: { color: '#fff',    background: '#8c8c8c', border: '#8c8c8c', label: 'Lainnya'         },
};

const PlatTag = ({ warna }) => {
	const cfg = WARNA_CONFIG[(warna || '').toUpperCase()] || WARNA_CONFIG.LAINNYA;
	return (
		<Tag style={{ color: cfg.color, background: cfg.background, borderColor: cfg.border, fontWeight: 600, padding: '1px 8px' }}>
			{cfg.label}
		</Tag>
	);
};

const formatTanggal = (val) => {
	if (!val) return '-';
	return String(val).substring(0, 10);
};

const KOLOM_DASAR = [
	{
		title: 'No Pol',
		dataIndex: 'nopol',
		key: 'nopol',
		width: 110,
		fixed: 'left',
		render: (v) => <strong>{v || '-'}</strong>,
	},
	{
		title: 'Nama Pemilik',
		dataIndex: 'nama_pemilik',
		key: 'nama_pemilik',
		width: 180,
		ellipsis: true,
		render: (v) => v || '-',
	},
	{
		title: 'NIK',
		dataIndex: 'nik',
		key: 'nik',
		width: 160,
		render: (v) => v || '-',
	},
	{
		title: 'Warna Plat',
		dataIndex: 'warna_plat',
		key: 'warna_plat',
		width: 130,
		render: (v) => <PlatTag warna={v} />,
	},
	{
		title: 'Jenis',
		key: 'jenis',
		width: 120,
		render: (_, row) => namaJenis(row.kode_jenis),
	},
	{
		title: 'Jatuh Tempo',
		dataIndex: 'sd_notice',
		key: 'sd_notice',
		width: 110,
		render: (v) => formatTanggal(v),
	},
	{
		title: 'Sumber',
		dataIndex: 'sumber',
		key: 'sumber',
		width: 80,
		render: (v) => (
			<Tag color={v === 'baru' ? 'blue' : 'default'} style={{ fontSize: 11 }}>
				{v || '-'}
			</Tag>
		),
	},
	{
		title: 'UPT',
		dataIndex: 'nama_upt',
		key: 'nama_upt',
		ellipsis: true,
		render: (v) => v || '-',
	},
];

const KOLOM_LUNAS = [
	...KOLOM_DASAR,
	{
		title: 'Tanggal Lunas',
		dataIndex: 'tanggal_lunas',
		key: 'tanggal_lunas',
		width: 130,
		render: (v) => formatTanggal(v),
	},
	{
		title: 'JT Baru',
		dataIndex: 'sd_notice_baru',
		key: 'sd_notice_baru',
		width: 110,
		render: (v) => formatTanggal(v),
	},
];

class ListTunggakanKendaraan extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			statusTab: 'aktif',
			search:    '',
			page:      1,
			pageSize:  50,
			loading:   false,
			total:     0,
			data:      [],
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData(overrides = {}) {
		const { statusTab, search, page, pageSize } = { ...this.state, ...overrides };
		const token   = Cookies.get(config.get_cookie_name());
		const baseUrl = config.get_base_url().replace(/\/$/, '');

		const params = new URLSearchParams({
			status:    statusTab,
			page:      page,
			page_size: pageSize,
		});
		if (search) params.set('search', search);

		const url = `${baseUrl}/${configClass.apiUrl.list}?${params.toString()}`;

		this.setState({ loading: true });

		fetch(url, { headers: { Authorization: token } })
			.then((res) => {
				if (!res.ok) return res.text().then((t) => { throw new Error(`HTTP ${res.status}: ${t.substring(0, 200)}`); });
				return res.json();
			})
			.then((json) => {
				this.setState({
					data:    json.results || [],
					total:   json.total   || 0,
					loading: false,
				});
			})
			.catch((err) => {
				message.error('Gagal memuat data: ' + (err.message || 'kesalahan tidak diketahui'));
				this.setState({ loading: false });
			});
	}

	handleTabChange(tab) {
		this.setState({ statusTab: tab, page: 1, data: [], total: 0 }, () => {
			this.fetchData();
		});
	}

	handleSearch() {
		this.setState({ page: 1 }, () => this.fetchData());
	}

	handleReset() {
		this.setState({ search: '', page: 1 }, () => this.fetchData());
	}

	handlePageChange(page, pageSize) {
		this.setState({ page, pageSize }, () => this.fetchData());
	}

	render() {
		const { statusTab, search, page, pageSize, loading, total, data } = this.state;
		const isLunas = statusTab === 'lunas';
		const kolom   = isLunas ? KOLOM_LUNAS : KOLOM_DASAR;

		return (
			<div>
				<Helmet>
					<title>{configClass.title} | Aplikasi</title>
				</Helmet>
				<Breadcrumb style={{ marginBottom: 16 }}>
					{configClass.breadCrumb.map((item, i) => (
						<Breadcrumb.Item key={i}>{item}</Breadcrumb.Item>
					))}
				</Breadcrumb>

				<Card
					title={
						<span>
							<UnorderedListOutlined style={{ marginRight: 8 }} />
							{configClass.title}
						</span>
					}
					size="small"
					style={{ marginBottom: 16 }}
				>
					<Typography.Paragraph style={{ margin: 0, color: '#666' }}>
						Daftar individual kendaraan tunggakan dari tabel sinkronisasi.
						Gunakan fitur Sinkronisasi DB di menu <strong>Tunggakan Kendaraan</strong> untuk memperbarui data.
					</Typography.Paragraph>
				</Card>

				<Card size="small">
					{/* Search bar */}
					<Row gutter={[8, 8]} style={{ marginBottom: 16 }}>
						<Col xs={24} sm={14} md={10}>
							<Input
								placeholder="Cari nomor polisi / nama / NIK..."
								value={search}
								onChange={(e) => this.setState({ search: e.target.value })}
								onPressEnter={() => this.handleSearch()}
								prefix={<SearchOutlined />}
								allowClear
								onClear={() => this.handleReset()}
							/>
						</Col>
						<Col>
							<Space>
								<Button
									type="primary"
									icon={<SearchOutlined />}
									onClick={() => this.handleSearch()}
									loading={loading}
								>
									Cari
								</Button>
								<Button
									icon={<ReloadOutlined />}
									onClick={() => this.handleReset()}
									disabled={loading}
								>
									Reset
								</Button>
							</Space>
						</Col>
					</Row>

					{/* Tabs */}
					<Tabs
						activeKey={statusTab}
						onChange={(tab) => this.handleTabChange(tab)}
						items={[
							{
								key:   'aktif',
								label: (
									<span>
										<WarningOutlined style={{ color: '#f5222d' }} />
										&nbsp;Belum Bayar
									</span>
								),
							},
							{
								key:   'lunas',
								label: (
									<span>
										<CheckCircleOutlined style={{ color: '#52c41a' }} />
										&nbsp;Sudah Bayar
									</span>
								),
							},
						]}
					/>

					<Table
						columns={kolom}
						dataSource={data.map((r) => ({ ...r, key: r.id }))}
						loading={loading}
						size="small"
						bordered
						scroll={{ x: isLunas ? 1400 : 1100 }}
						pagination={{
							current:   page,
							pageSize:  pageSize,
							total:     total,
							showSizeChanger: true,
							pageSizeOptions: ['25', '50', '100', '200'],
							showTotal:  (tot) => `Total ${tot.toLocaleString('id-ID')} kendaraan`,
							onChange:   (p, ps) => this.handlePageChange(p, ps),
						}}
					/>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(mapStateToProps, {
	initHandler,
	ajaxViewHandler,
	setConfig,
})(ListTunggakanKendaraan);
